import type { SVGProps } from 'react';

export default function CarEngine(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 7.5V5M11.75 4.75H16.25M13 10.75L11.75 13.25H14.25L13 16.25M5.75 10.75H7L9.41421 8.33579C9.78929 7.96071 10.298 7.75 10.8284 7.75H18.25C18.8023 7.75 19.25 8.19772 19.25 8.75V16.25C19.25 16.8023 18.8023 17.25 18.25 17.25H17L15 19.25H10L7.29289 16.5429C7.10536 16.3554 6.851 16.25 6.58579 16.25H5.75C5.19772 16.25 4.75 15.8023 4.75 15.25V11.75C4.75 11.1977 5.19772 10.75 5.75 10.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
